/* Rankings And Accolades Data */
const RankingData = [
    {
        id: 0,
        name:'American Express',
        desc: 'American Express appreciated NITJ for its hard-work and committed efforts to bridge the gap between industry and academia.',
        imgLink: 'https://1000logos.net/wp-content/uploads/2016/10/American-Express-Color.png',
    },
    {
        id: 1,
        name:'Microsoft',
        desc: 'Microsoft appreciated NITJ for its hard-work and committed efforts to make students highly skilled in different skills, and passionate about work.',
        imgLink: 'https://img-prod-cms-rt-microsoft-com.akamaized.net/cms/api/am/imageFileData/RWCZER?ver=1433&q=90&m=6&h=195&w=348&b=%23FFFFFFFF&l=f&o=t&aim=true',
    },
    {
        id: 2,
        name:'Google',
        desc: 'Google has reognized as one of the best colleges around the country and has appreciated for good performance of students.',
        imgLink: 'https://play-lh.googleusercontent.com/1-hPxafOxdYpYZEOKzNIkSP43HXCNftVJVttoo4ucl7rsMASXW3Xr6GlXURCubE1tA=w3840-h2160-rw',
    },
    {
        id: 3,
        name:'Amazon',
        desc: 'Amazon appreciated NITJ for its hard-work and committed efforts to make sure every student in the college gets all facilities.',
        imgLink: 'https://m.media-amazon.com/images/G/31/social_share/amazon_logo._CB633266945_.png',
    },
    {
        id: 4,
        name:'Cvent',
        desc: 'Cvent appreciated NITJ for its good services and the wonderful services during it\'s recruitment carried out duringg last years.',
        imgLink: 'https://meri.edu.in/meri/wp-content/uploads/2021/06/cvent-logo-standard.jpg',
    },
    {
        id: 5,
        name:'Deloitte',
        desc: 'Deloitte have recognized NIT Jalandhar for having highest number of placements in the college for last couple of years.',
        imgLink: 'https://www2.deloitte.com/content/dam/Deloitte/us/Images/promo_images/deloitte/us-deloitte-logo.jpg',
    }
];

export default RankingData;